export default {
    startParams: {
        affinity: {
            min: 0,
            max: 700,
            filterString: "Drægni frá [min] km. til [max] km. "
        },
        towing_capacity: {
            min: 0,
            max: 3500,
            step: 10,
            filterString: "Dráttargeta frá  [min] kg. til [max] kg. "
        },
        engine: {
            min: 0,
            max: 5000,
            step: 10,
            filterString: "Slagrými frá [min] til [max] "
        },
        horse_power: {
            min: 0,
            max: 800,
            step: 10,
            filterString: "Hestöfl frá  [min] hö. til [max] hö."
        },
        co2: {
            min: 0,
            max: 300,
            step: 10,
            filterString: "CO2 frá  [min] til [max]"
        },
        battery_capacity: {
            min: 0,
            max: 100,
            step: 1,
            filterString: "Stærð rafhlöðu frá  [min] kWh til [max] kWh"
        }
    },
    asideList: {
        affinity: {
            title: 'Drægni',
            type: 'slider',
            name: 'affinity',
            unit: 'km.'
        },
        towing_capacity: {
            title: 'Dráttargeta',
            name: 'towing_capacity',
            unit: 'kg.',
            type: 'slider',
        },
        battery_capacity: {
            title: 'Stærð rafhlöðu',
            type: 'slider',
            name: 'battery_capacity',
            unit: 'kWh'
        },
        /*engine: {
            title: 'Slagrými',
            type: 'slider',
            name: 'engine',
            unit: 'cc.'
        },*/
        horse_power: {
            title: 'Hestöfl',
            type: 'slider',
            name: 'horse_power',
            unit: 'hö.'
        },
        /*co2: {
            title: 'co2',
            type: 'slider',
            name: 'co2',
            unit: ''
        },*/
        /*seats_number:{
            type: 'dropDown',
            title: 'Farþegafjöldi',
            name: 'seats_number',
            lib: 'seats_number'
        },*/
        cat:{
            title: 'Stærð og gerð',
            type: 'dropDown',
            name: 'cat',
            lib: 'cat_new_cars'
        },
        drif:{
            type: 'dropDown',
            title: 'Drif',
            name: 'drif',
            lib: 'drif'
        },
        aukahlutir:{
            title: 'Aukahlutir',
            lib: 'aukahlutir',
            type: 'dropDown',
            name: 'aukahlutir'
        }
    }
}
